import { useTranslation } from 'react-i18next';

import { Stack } from '@mui/material';

import Tooltip from '../../../../../../components/Tooltip';
import { i18nNS } from '../../../../../../i18n';
import InformationIcon from '../../../../../../icons/InformationIcon';
import { InformationButton } from './styles';
import InformationDialog from './InformationDialog';
import useInformation from './vm';

const Information = () => {
  const { t } = useTranslation([i18nNS.GLOSSARY]);

  const { isInformationDialogOpen, onInformationClick, onInformationDialogClose } = useInformation();

  return (
    <>
      <Tooltip title={t('information', { ns: i18nNS.GLOSSARY })}>
        {/** Stack is used to provide reference to the tooltip and to remove extra padding inside this wrapper */}
        <Stack>
          <InformationButton onClick={onInformationClick}>
            <InformationIcon size={20} color="primary" />
          </InformationButton>
        </Stack>
      </Tooltip>
      <InformationDialog open={isInformationDialogOpen} onClose={onInformationDialogClose} />
    </>
  );
};

export default Information;
